<template>
  <a-modal
    class="dialog-body"
    width="auto"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
    :keyboard="false"
    :maskClosable="false"
  >
    <div style="display: flex;">
      <img :src="require(`@/assets/progress.png`)" width="650" alt="">
      <div style="flex:1;border-left: 1px solid #d6d6d6;padding-left: 20px">
        <h1 class="title">项目概述</h1>
        <a-form-model layout="vertical" :model="model" ref="ruleForm" :rules="rules">
          <a-form-model-item
            class="label"
            prop="name"
            label="项目名称">
            <a-input placeholder="请输入项目名称" v-model="model.name"  class="input"/>
          </a-form-model-item>
          <a-form-model-item
            class="label"
            prop="startDate"
            label="预计开始时间">
            <a-date-picker :inputReadOnly="true" value-format='YYYY-MM-DD' class="date"style="width: 100%;height:54px" v-model="model.startDate" />
          </a-form-model-item>
          <a-form-model-item
            class="label"
            prop="centerIdList"
            label="项目实施中心">
            <a-select v-model="model.centerIdList" mode="multiple" @change="centerChange" class="select ccccc">
              <a-select-option :value="item.id" v-for="item in centerList">{{item.name}}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item
            class="label"
            prop="beforeTest"
            label="开启预实验">
             <a-radio-group v-model="model.beforeTest" >
              <a-radio-button value="0">
                否
              </a-radio-button>
              <a-radio-button value="1">
                是
              </a-radio-button>
            </a-radio-group> 
            0,1 -->
           <!--  <div class="input switch">
              <a-switch v-model:checked="model.beforeTest" />
            </div>
          </a-form-model-item>
          <a-form-model-item
            class="label"
            prop="testNum"
            label="预实验人数" v-show="model.beforeTest">
            <a-input-number v-model="model.testNum" :min="0" :max="50" :precision="0" class="input-num"/>
          </a-form-model-item> -->
          <a-form-model-item
            class="label"
            prop="manyType"
            label="开启多病种研究">
            <!-- <a-radio-group v-model="model.manyType" >
              <a-radio-button value="0">
                否
              </a-radio-button>
              <a-radio-button value="1">
                是
              </a-radio-button>
            </a-radio-group> -->
            <div class="input switch">
              <a-switch v-model:checked="model.manyType" />
            </div>
          </a-form-model-item>
          <a-form-model-item
            class="label"
            prop="personId"
            label="项目负责人">
            <!-- <a-input placeholder="请输入项目负责人" v-model="model.personName" style="width: 200px" readOnly /> <a-button icon="search" style="margin-left: 10px" @click="selectUserView()"></a-button> -->
            <!--  @click="selectUserView"
              @search="selectUserView"
            -->
            <a-input
              class="input"
              v-model="model.personName"
              placeholder="请输入项目负责人"
              :readOnly="true"
            />
          </a-form-model-item>
          <a-form-model-item
            class="label"
            prop="phone"
            label="联系电话">
            <a-input placeholder="请输入联系电话" v-model="model.phone" class="input"/>
          </a-form-model-item>
          <a-form-model-item
            class="label"
            prop="abstract"
            label="项目简介">
            <a-textarea :rows="4" placeholder="请输入项目简介" v-model="model.intro"  class="textarea"/>
          </a-form-model-item>
        </a-form-model>
        <div style="text-align: right" v-if="model.id">
          <a-button type="danger" @click="deleteProject">删除</a-button>
        </div>
      </div>
    </div>



    <Select-User-Modal ref="selectUserModal" :single="'1'" @selectFinished="selectUserOK"></Select-User-Modal>
    <template slot="footer">
      <gradient-btn @click="handleOk">确认</gradient-btn>
    </template>
  </a-modal>
</template>

<script>
  import { mapActions, mapGetters,mapState } from 'vuex'
  import { deleteAction, getAction, postAction } from '@/api/manage'
  import SelectUserModal from '@/views/system/modules/SelectUserModal'
  import baseRules from '@/constants/baseRules'
  import GradientBtn from '@comp/pad/GradientBtn'
  export default {
    name: 'ProjectCreateModel',
    components: { SelectUserModal,GradientBtn },
    props:{

    },
    data(){
      return {
        rules:{
          name:[baseRules.required],
          startDate:[baseRules.requiredChange],
          centerIdList:[baseRules.requiredChange],
          beforeTest:[baseRules.requiredChange],
          // testNum:[baseRules.required],
          manyType:[baseRules.requiredChange],
          // personId:[baseRules.requiredChange],
          phone:[baseRules.required],

        },
        model:{
          centerIdList:[],
          centerNameList:[],
          beforeTest:'0',
          manyType:'0',
          type:0,//0:新建；1：编辑
        },
        centerList:[],
        visible:false,
        confirmLoading:false,
      }
    },
    watch:{

    },
    mounted(){
      this.getCenterList();
    },
    methods:{
      ...mapGetters(["userInfo"]),
      add(){
        this.initHandle({
          type:0,//新建
          centerIdList:[],
          centerNameList:[],
          beforeTest:'0',
          manyType:'0',
          personName:this.userInfo().realname,
          phone:this.userInfo().phone,
          personId:this.userInfo().id
        })
      },
      edit(model){
        this.initHandle({
          ...model,
          type:1,//编辑
          personName:this.userInfo().realname,
          phone:model.contactPhone,//this.userInfo().phone,
          personId:this.userInfo().id
        })
      },
      initHandle(model){
        model = JSON.parse(JSON.stringify(model));
        model.centerIdList =model.centerIds? model.centerIds.split(',') :[]
        delete model.centerIds
        model.centerNameList = model.centerNames?model.centerNames.split(','):[]
        delete model.centerNames
        model.beforeTest = model.beforeTest === '0'?false:true;
        model.manyType = model.manyType === '0'?false:true;
        this.model = model
        this.visible = true
      },
      handleCancel(){
        this.visible = false
      },
      handleOk(){
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            const model = JSON.parse(JSON.stringify(this.model));
            model.centerIds = model.centerIdList.join(',')
            delete model.centerIdList
            model.centerNames = model.centerNameList.join(',')
            delete model.centerNameList
            model.beforeTest = model.beforeTest === true ? '1':'0'
            model.manyType = model.manyType === true ? '1':'0'
            this.confirmLoading = true
            postAction('/projectconfigview/configProject/save',model).then(res=>{
              if(res.success){
                // const createId = !this.model.id ?res.result.id:null
                const id = model.type == 0 ?res.result.id:model.projectConfigId;
                this.handleCancel()
                this.$emit('submit',id)
              }else{
                this.$message.error('后台请求异常')
              }
            }).finally(()=>{
              this.confirmLoading = false
            })
          }
        })
      },
      getCenterList(){
        getAction('/management/center/listAll',{status:'1'}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }else{
            this.$message.error('后台请求异常')
          }
        })
      },
      selectUserView(){
        this.$refs.selectUserModal.visible = true;
      },
      selectUserOK(keys,records){
        const record = records[0]
        // 项目联系人
        this.$set(this.model,'personName',record.realname)
        this.$set(this.model,'personId',record.id)
        if(!this.model.phone){
          this.$set(this.model,'phone',record.phone || record.telephone)
        }
      },
      centerChange(keys){
        const centerNameList = []
        this.centerList.forEach(item=>{
          for (let i = 0; i < keys.length; i++) {
            const key = keys[i]
            if(item.id==key){
              centerNameList.push(item.name)
              break
            }
          }
        })
        this.$set(this.model,'centerNameList',centerNameList)
      },
      deleteProject(){
        this.$confirm({
          title: '彻底删除',
          content: (<div>
            <p>您确定要彻底删除这个项目配置吗？</p>
            <p style="color:red;">注意：彻底删除后将无法恢复，请谨慎操作！</p>
          </div>),
          centered: false,
          onOk: () => {
            deleteAction("/projectconfigview/configProject/delete",{id:this.model.id}).then((res) => {
              if (res.success) {
                this.$message.success(res.message)
                this.handleCancel()
                this.$emit('deleteChange')
              } else {
                this.$message.warning(res.message);
              }
            });
          },
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .dialog-body{
    /deep/ .ant-modal-content{
      border-radius: 24px;
      //background-image: url(~@/assets/modal-bg.png);
      // background-color: #252626;
      //background-repeat: no-repeat;
      // background-color: gray;
    }
    /deep/ .ant-modal-close-icon{
      // color: white;
    }

    /deep/ .ant-modal-footer{
      text-align: center;
      padding: 20px 0;
    }

    .has-error .ant-input, .has-error .ant-input:hover{
      // background: rgba(255, 255, 255, 0.15);
    }

    /deep/ .ant-form-item{
      margin-bottom: 10px;
      padding-bottom: 0;
    }
  }
  .label{
    /deep/ .ant-form-item-required{
      // color:white;
    }
    /deep/ label{
      // color:white;
    }
  }
  
  .title{
    text-align: center;
    font-size: 16px;
    // color: white;
  }
  .input{
    width: 100%;
    // color:white;
    height: 54px;
    // border: 0;
    border-radius: 12px;
    // background: rgba(255,255,255,0.15);
    background-color: #F2F2F2;
  }

  .input-num {
    width: 100%;
    height: 54px;
    // color:white;
      // border: 0;
      border-radius: 12px;
      // background: rgba(255,255,255,0.15);
      background-color: #F2F2F2;
    /deep/ .ant-input-number-input-wrap{
      height: 100%;
      input{
        height: 100%;
      }
    }
  }

  .date {
    color:orange;
     /deep/ input {
      // color:white;
      height: 54px;
      // border: 0;
      border-radius: 12px;
      // background: rgba(255,255,255,0.15);
      background-color: #F2F2F2;
    }
  }

  .search-input{
    border-radius: 12px;
    // background: rgba(255,255,255,0.15);
    background-color: #F2F2F2;
    /deep/ input {
      // color:white;
      height: 54px;
      // border: 0;
      // background: transparent !important;
    }
  }



  .select{
    height: 54px;
    /deep/ .ant-select-selection{
      // border: 0;
      border-radius: 12px;
      // background: transparent;
      // background: rgba(255,255,255,0.15);
      background-color: #F2F2F2;
    }
    /deep/ ul li{
      height: 46px;
      line-height: 46px;
    }
  }

  .switch{
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .textarea{
    width: 100%;
    // border: 0;
    // color:white;
    border-radius: 12px;
    // background: rgba(255,255,255,0.15);
    background-color: #F2F2F2;
  }
</style>